import { Location } from "@angular/common";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";

import { Unsubscriber } from "@shared/Components/Unsubscriber/unsubscriber.component";

import { UnitSharedService } from "@Unit/shared/services/unitshared.service";
import { PORTAL_STYLES } from "@Unit/shared/Type/config/portal-style.config";

import { MenuSection } from "../Types/menu.interface";

@Component({
  selector: "app-desktop-menu",
  templateUrl: "./desktop-menu.component.html",
  styleUrls: ["./desktop-menu.component.scss"],
})
export class DesktopMenuComponent extends Unsubscriber implements OnInit {
  @Input() public menu: MenuSection[] = [];

  public showAll: boolean = true;
  public selectedChild?: MenuSection;
  public selectedSection: MenuSection;
  public selectedChildFiltered: MenuSection;

  public isMenuOpen = false;
  public isUnitPortalStyle: boolean = false;

  @ViewChild("scrollContainer") public scrollContainer: ElementRef;

  constructor(
    public readonly router: Router,
    private readonly unitSharedService: UnitSharedService,
    private readonly location: Location
  ) {
    super();
    this.unitSharedService.isUnitPortalStyle$.subscribe((isUnit) => {
      this.isUnitPortalStyle = isUnit;
    });
  }

  public ngOnInit(): void {
    this.anotherSubscription = this.router.events.subscribe(() => {
      this.closeMenu();
    });
  }

  // Devuelve el estilo del portal desde sessionStorage
  public getPortalStyleFromSession(): string {
    return localStorage.getItem("PortalStyle") || "";
  }

  public getButtonClass(sectionName: string): string {
    if (sectionName === "SEGUROS UNIVERSAL") {
      return "universal-style";
    } else if (sectionName === "SEGUROS UNIT") {
      return "unit-style";
    }
    return "normal-style";
  }

  public navigateToPortal(portalName: string): void {
    const unitRegExp = /unit/i;
    if (unitRegExp.test(portalName.toLocaleLowerCase())) {
      localStorage.setItem("PortalStyle", PORTAL_STYLES.unit.portalStyle);
    } else {
      localStorage.setItem("PortalStyle", PORTAL_STYLES.universal.portalStyle);
    }
    // this.router.navigateByUrl("portales");
    this.location.go(`portales`);
    setTimeout(() => {
      window.location.reload();
    }, 50);
  }

  public onClickOutside(): void {
    this.closeMenu();
  }

  public closeMenu(): void {
    this.showAll = false;
    this.isMenuOpen = false;
    this.selectedChild = null;
    this.selectedSection = null;
  }

  public onSelectSection(section: MenuSection): void {
    if (section.id === this.selectedSection?.id) {
      this.closeMenu();
    } else {
      this.showAll = false;
      this.isMenuOpen = true;
      this.selectedChild = section?.childs[0];
      this.selectedSection = section;
    }
  }

  public onSelectChild(child: MenuSection, index: number, navigate: boolean = true): void {
    this.selectedChild = child;
    if (child.childs.length === 1 && navigate) this.router.navigateByUrl(child.childs[0].url);

    const sectionHeight = 63;
    this.scrollContainer.nativeElement.scrollTo({
      top: index * sectionHeight,
      behavior: "smooth",
    });
  }

  public toggleShowAll(event?: MouseEvent): void {
    event.stopPropagation();
    this.showAll = !this.showAll;
  }

  public selectNextChild(): void {
    const nextIndex = this.selectedSection.childs.findIndex((section) => section.id === this.selectedChild?.id) + 1;
    const selectedChild =
      nextIndex !== this.selectedSection.childs.length ? this.selectedSection.childs[nextIndex] : this.selectedChild;

    this.onSelectChild(selectedChild, nextIndex, false);
  }

  public get isLastChildSelected(): boolean {
    return (
      this.selectedSection.childs.findIndex((section) => section.id === this.selectedChild?.id) ===
      this.selectedSection.childs.length - 1
    );
  }
}
